import React, { CSSProperties, ReactNode } from "react";
import classes from "./Card.module.scss";

interface CardProps {
  children: ReactNode;
  style?: CSSProperties;
}

const Card: React.FC<CardProps> = (props) => {
  return (
    <div className={classes.card} style={props.style}>
      {props.children}
    </div>
  );
};

export default Card;
